import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
      pxCorrectionMobile,
      pxCorrectionDesktop,
      mobileBreakpoint,
      container
    } = config;
    this.trigger = accordions;
    this.pxCorrectionMobile = pxCorrectionMobile;
    this.pxCorrectionDesktop = pxCorrectionDesktop;
    this.mobileBreakpoint = mobileBreakpoint;

    // Attach a delegated click handler on a stable container to survive DOM mutations
    this.container = document.querySelector(container || '.iz-content__content') || document;

    // Guard against adding multiple listeners on the same container across navigations
    if (!this.container.__accordionDelegatedBound) {
      this.handleDelegatedClick = this.onDelegatedClick.bind(this);
      this.container.addEventListener('click', this.handleDelegatedClick);
      this.container.__accordionDelegatedBound = true;
    }

    // For hash navigation we still need to open accordions programmatically
    this.handleHashNavigation();
  }

  onDelegatedClick(event) {
    const innerHead = event.target && (event.target.closest ? event.target.closest('.lc-accordion__inner-head') : null);
    if (!innerHead || !this.container.contains(innerHead)) return;

    const accordion = innerHead.closest('.lc-accordion');
    if (!accordion) return;

    const content = accordion.querySelector('.lc-accordion__content');
    if (!content) return;

    if (innerHead.classList.contains('active')) {
      Helper.slideClose(content);
      innerHead.classList.remove('active');
      content.classList.remove('active');
    } else {
      innerHead.classList.add('active');
      Helper.slideOpen(content, true);
      content.classList.add('active');
    }
  }

  handleHashNavigation() {
    const url = location.href;
    const id = url.split('#');

    if (id[1]) {
      const targetElement = document.querySelector(`#${id[1]}`);

      if (targetElement) {
        // Find all parent accordions
        const parentAccordions = this.findParentAccordions(targetElement);

        // Open all parent accordions
        parentAccordions.forEach(accordion => {
          if (!accordion) return;

          const innerHead = accordion.querySelector('.lc-accordion__inner-head');
          const content = accordion.querySelector('.lc-accordion__content');

          if (innerHead && !innerHead.classList.contains('active')) {
            innerHead.classList.add('active');
            if (content) {
              Helper.slideOpen(content, true);
              content.classList.add('active');
            }
          }
        });

        // Scroll to the element after a short delay to allow accordions to open
        setTimeout(() => {
          const headerOffset = document.querySelector('.iz-header')?.offsetHeight || 0;
          const pxCorrection = this.setPxCorrection();
          const elementPosition = targetElement.offsetTop;

          window.scrollTo({
            top: elementPosition - headerOffset - pxCorrection,
            behavior: "smooth"
          });
        }, 300);
      }
    }
  }

  findParentAccordions(element) {
    if (!element) return [];

    const parentAccordions = [];
    let currentElement = element;

    while (currentElement) {
      const accordion = currentElement.closest('.lc-accordion');
      if (accordion) {
        parentAccordions.unshift(accordion);
      }
      currentElement = currentElement.parentElement;
    }

    return parentAccordions;
  }

  setPxCorrection() {
    if (window.innerWidth >= this.mobileBreakpoint) {
      return this.pxCorrectionDesktop;
    } else {
      return this.pxCorrectionMobile;
    }
  }
}

export default Accordion;
